import { Emplooyee } from './../../common/entities/employee';
import { TaskSaveService } from './../../task/services/task-save.service';
import { Component, OnInit } from '@angular/core';
import { EmployeeService } from 'app/modules/employee/services/employee.service';
import { EmployeeStoreService } from 'app/modules/employee/services/employee-store.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import { MatDialog } from '@angular/material/dialog';
import { AddEditWarningPopupComponent } from '../warning-panel/add-edit-warning-popup/add-edit-warning-popup.component';
import { LeaveReportPopupComponent } from '../common/popups/leave-report-popup/leave-report-popup.component';
import { CostReportPopupComponent } from '../common/popups/cost-report-popup/cost-report-popup.component';
import { Subscription } from 'rxjs';
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})

export class HeaderComponent implements OnInit {
    apellidos: any;
    nombre: any;
    prueba: any;
    private EmployeeId: any;
    public permissions: Array<string>;
    EmployeeDetailSubcription: Subscription;
    empresaId: number;
    task:Emplooyee =new Emplooyee();;
    constructor(
        public employeeService: EmployeeService,
        public employeeStoreService: EmployeeStoreService,
        private sharedService: SharedService,
        public taskService: TaskSaveService,
        private dialog: MatDialog) {
        this.EmployeeId = localStorage.getItem('EmplooyeeID');
        if (this.EmployeeId) {
            this.employeeService.getEmployeeDetails(this.EmployeeId);
            this.employeeService.getheaderDetails(this.EmployeeId).subscribe(rs => {
                const data = localStorage.getItem('EmplooyeeData');

                if (data.charAt(0) === '[') {
                    this.employeeService.currentEmployee = JSON.parse(data[0]);
                }

                if (data.charAt(0) === '{') {
                    this.employeeService.currentEmployee = JSON.parse(data);
                }

                this.employeeStoreService.setEmployeeHeaderData();
                this.sharedService.setCurrentEmployeeName(`${(this.employeeService.currentEmployee).apellidos}, ${(this.employeeService.currentEmployee).nombre}`);
            });

        }
        this.employeeService.selectUserData.subscribe((_res: any) => {
            this.getHeaderDetails();
        });

        this.employeeService.selectUserappointment.subscribe((_res: any) => {
            this.getHeaderDetails();
        });

        this.employeeService.saveemplooye.subscribe((_res: any) => {
            this.getHeaderDetails();
        });
    }

    ngOnInit(): void {
        this.permissions = this.sharedService.getCurrentUserPermissions();
    }
    PrintCartaLopd() {
        this.task.trabajadorId=this.EmployeeId;
        this.taskService.OnPrintLOPDDocument(this.task);
      }
    getHeaderDetails(): void {
        this.EmployeeId = localStorage.getItem('EmplooyeeID');
        this.employeeService.getEmployeeDetails(this.EmployeeId);
        this.employeeService.getheaderDetails(this.EmployeeId);
        this.employeeService.getEmployeeDetailsForHeader(this.EmployeeId).subscribe(res => {
            this.employeeService.currentEmployee = res.result[0];
            this.employeeStoreService.setEmployeeHeaderData();
        });
    }

    public CreateWarningMessage(): void {
        const dialogRef = this.dialog.open(AddEditWarningPopupComponent);
        dialogRef.componentInstance.EmployeeId = this.EmployeeId;
    }

    public OpenLeaveReportPopup(): void {
        const dialogRef = this.dialog.open(LeaveReportPopupComponent);
        dialogRef.afterClosed().subscribe(res => {
            // Do whats needed to be done after the popup closes
        });
    }

    public OpenCostReportPopup(): void {
        const dialogRef = this.dialog.open(CostReportPopupComponent);
        dialogRef.afterClosed().subscribe(res => {
            // Do whats needed to be done after the popup closes
        });
    }
}
